import { BinderFailuresByWarrantyType, OffersWarrantyType } from "@dune/types";
import { offersWarrantyTypes } from "@dune/vars";

export const isFailureResponse = (
	data: unknown,
): data is BinderFailuresByWarrantyType => {
	if (!data || Array.isArray(data) || typeof data !== "object") {
		return false;
	}
	const failureData = data as BinderFailuresByWarrantyType;
	return Boolean(failureData.DOCARAVELA || failureData.TRCCARAVELA || failureData.DOAXERIA || failureData.TRCAXERIA || failureData.MRT || failureData.PJ);
};

export const getWarrantyTypeDisplayName = (warrantyType: string) => {
	switch (warrantyType) {
		case "DOCARAVELA":
			return "Dommages Ouvrage CARAVELA";
		case "TRCCARAVELA":
			return "Tous Risques Chantier CARAVELA";
		case "DOAXERIA":
			return "Dommages Ouvrage AXERIA";
		case "TRCAXERIA":
			return "Tous Risques Chantier AXERIA";
		case "MRT":
			return "Multirisques Travaux ZURICH";
		case "PJ":
			return "Protection Juridique CFDP";
		default:
			return warrantyType;
	}
};

export const isOfferWarrantyType = (
	warrantyType?: string | null,
): warrantyType is OffersWarrantyType => {
	return offersWarrantyTypes.includes(warrantyType as OffersWarrantyType);
};
